import { render, staticRenderFns } from "./QueueTemplateDetails.vue?vue&type=template&id=7938ce22&"
import script from "./QueueTemplateDetails.vue?vue&type=script&lang=js&"
export * from "./QueueTemplateDetails.vue?vue&type=script&lang=js&"
import style0 from "./QueueTemplateDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports